import React from "react";
import { FareInfographicVariant } from "./FareInfographic";
import styles from "./FareInfographic.module.scss";
import clsx from "clsx";
import Skeleton from "react-loading-skeleton";

export type FareInfographicSkeletonProps = {
  expandable: boolean;
  isExpanded?: boolean;
  variant?: FareInfographicVariant;
};
export const FareInfographicSkeleton: React.FC<
  FareInfographicSkeletonProps
> = ({ expandable, isExpanded = false, variant = "default" }) => {
  const groupExpanded = variant == "full-horizontal" || isExpanded;
  return (
    <div
      className={clsx(styles.container, {
        [styles.variantDefault]: variant == "default",
        [styles.variantFullHorizontal]: variant == "full-horizontal",
        [styles.variantAlwaysVertical]: variant == "always-vertical",
        [styles.expandable]: expandable,
        [styles.static]: !expandable,
        [styles.isExpanded]: isExpanded,
        [styles.isCollapsed]: !isExpanded
      })}
    >
      <ul className={styles.groups}>
        <FareInfographicGroupSkeleton
          id="pre-cruise"
          isExpanded={groupExpanded}
        />
        <FareInfographicGroupSkeleton id="cruise" isExpanded={groupExpanded} />
        <FareInfographicGroupSkeleton id="shorex" isExpanded={groupExpanded} />
        <FareInfographicGroupSkeleton
          id="post-cruise"
          isExpanded={groupExpanded}
        />
      </ul>
    </div>
  );
};

type FareInfographicGroupSkeleton = {
  id: string;
  isExpanded: boolean;
};

const FareInfographicGroupSkeleton: React.FC<FareInfographicGroupSkeleton> = ({
  id,
  isExpanded
}) => {
  const renderSteps = isExpanded;
  return (
    <li
      key={id}
      className={clsx(styles.group, {
        [styles.isShorex]: id == "shorex",
        [styles.isPreCruise]: id == "pre-cruise",
        [styles.isPostCruise]: id == "post-cruise"
      })}
    >
      <div className={styles.groupHeaderIcon}>
        <Skeleton count={1} height={40} width={40} circle />
      </div>
      <div className={styles.groupHeader}>
        <Skeleton count={1} width={"80px"} />
      </div>

      {renderSteps && (
        <ul className={styles.steps}>
          <li className={styles.step}>
            <Skeleton count={1} width={"80px"} />
          </li>
          <li className={styles.step}>
            <Skeleton count={1} width={"80px"} />
          </li>
        </ul>
      )}
    </li>
  );
};
